import { AxiosInstance } from 'axios';

import { ExpandPromiseResponse } from '@sv-support-sdk/shared-types/src/common/utils';

export interface TicketResponse {
  errors?: string | string[];
  id: number;
  localizationName?: string;
  hash?: string;
}

export default (api: AxiosInstance) => ({
  createTicket: <T>(data?: any): ExpandPromiseResponse<TicketResponse, T> =>
    api.post('ticket', data),
});
